/**
 * @file buffer.js
 */
'use strict';

exports.__esModule = true;
exports.bufferedPercent = bufferedPercent;

var _timeRangesJs = require('./time-ranges.js');

/**
 * Compute how much your video has been buffered
 *
 * @param  {Object} Buffered object
 * @param  {Number} Total duration
 * @return {Number} Percent buffered of the total duration
 * @private
 * @function bufferedPercent
 */

function bufferedPercent(buffered, duration) {
  var bufferedDuration = 0,
      start,
      end;

  if (!duration) {
    return 0;
  }

  if (!buffered || !buffered.length) {
    buffered = _timeRangesJs.createTimeRange(0, 0);
  }

  for (var i = 0; i < buffered.length; i++) {
    start = buffered.start(i);
    end = buffered.end(i);

    // buffered end can be bigger than duration by a very small fraction
    if (end > duration) {
      end = duration;
    }

    bufferedDuration += end - start;
  }

  return bufferedDuration / duration;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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